// ════════════════════════════════════════════════════════════════════════════
// sceneAmbienceManifest.ts
//
// Real recorded environment ambience, keyed by scene. When an entry exists
// the gameAudio module loops a clip at low gain underneath the SFX/music.
// Scenes with no recording fall back to silence (or just music).
//
// FILES LIVE AT:
//   frontend/public/sounds/scenes/<scene>/<scene>[_<n>].mp3
//
// REGENERATE with: node tools/build_scene_ambience_manifest.mjs
// ════════════════════════════════════════════════════════════════════════════

export type SceneAmbienceKey =
  | 'meadow_day' | 'meadow_night'
  | 'blossom' | 'beach' | 'autumn' | 'starry'
  | 'magical_forest' | 'cloud_kingdom' | 'underwater'
  | 'chat' | 'quiz' | 'shop' | 'habits' | 'zoo'
  | 'wallet' | 'journal' | 'imagine';

export type SceneAmbienceManifest = Record<SceneAmbienceKey, string[]>;

export const SCENE_AMBIENCE_MANIFEST: SceneAmbienceManifest = {
  meadow_day: ['/sounds/scenes/meadow_day/meadow_day.mp3'],
  meadow_night: ['/sounds/scenes/meadow_night/meadow_night.mp3'],
  blossom: ['/sounds/scenes/blossom/blossom.mp3'],
  beach: ['/sounds/scenes/beach/beach.mp3'],
  autumn: ['/sounds/scenes/autumn/autumn.mp3'],
  starry: ['/sounds/scenes/starry/starry.mp3'],
  magical_forest: ['/sounds/scenes/magical_forest/magical_forest.mp3'],
  cloud_kingdom: ['/sounds/scenes/cloud_kingdom/cloud_kingdom.mp3'],
  underwater: ['/sounds/scenes/underwater/underwater.mp3'],
  chat: ['/sounds/scenes/chat/chat.mp3'],
  quiz: ['/sounds/scenes/quiz/quiz.mp3'],
  shop: ['/sounds/scenes/shop/shop.mp3'],
  habits: ['/sounds/scenes/habits/habits.mp3'],
  zoo: ['/sounds/scenes/zoo/zoo.mp3'],
  wallet: ['/sounds/scenes/wallet/wallet.mp3'],
  journal: ['/sounds/scenes/journal/journal.mp3'],
  imagine: ['/sounds/scenes/imagine/imagine.mp3'],
};

export const SCENE_AMBIENCE_KEYS: SceneAmbienceKey[] = [
  'meadow_day', 'meadow_night',
  'blossom', 'beach', 'autumn', 'starry',
  'magical_forest', 'cloud_kingdom', 'underwater',
  'chat', 'quiz', 'shop', 'habits', 'zoo',
  'wallet', 'journal', 'imagine',
];
